module.exports = "/_next/static/images/unlock-3beddee587c3486143debe3c99ba7c3d.svg";